import { render, staticRenderFns } from "./EditLogDialog.vue?vue&type=template&id=2fcd8b74&scoped=true"
import script from "./EditLogDialog.vue?vue&type=script&lang=js"
export * from "./EditLogDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd8b74",
  null
  
)

export default component.exports